import { render, staticRenderFns } from "./ChangeAccountTraitBtn.vue?vue&type=template&id=27ee1428&"
import script from "./ChangeAccountTraitBtn.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountTraitBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports